import { isBrowser } from '../isBrowser';

export function getPageUrl(page: number, originalUrl: string): string {
  let url: URL;

  if (isBrowser()) {
    url = new URL(window.location.href);
  } else {
    url = new URL(originalUrl.startsWith('/') ? `https://www.cian.ru${originalUrl}` : originalUrl);
  }

  url.searchParams.set('p', page.toString());

  return `${url.pathname}${url.search}${url.hash}`;
}
